<script>
export default {
  name: "ArticleContentElaborations",
  props: {
    word: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <div class="indentation-container">
    <div
      v-if="word.wordClass"
      class="article-content__politiken-word-elaboration article-content__politiken-grid"
    >
      <span class="article-content__text article-content__politiken-grid-label">Ordklasse: </span>
      <span
        class="article-content__text article-content__text--primary article-content__politiken-grid-content"
        v-html="word.wordClass"
      />
    </div>
    <div
      v-if="word.flexion"
      class="article-content__politiken-word-elaboration article-content__politiken-grid"
    >
      <span class="article-content__text article-content__politiken-grid-label">Bøjes:</span>
      <span
        class="article-content__text article-content__text--primary article-content__politiken-grid-content"
        v-html="word.flexion"
      />
    </div>
    <div
      v-if="word.alternativeSpelling"
      class="article-content__politiken-word-elaboration article-content__politiken-grid"
    >
      <span class="article-content__text article-content__politiken-grid-label">
        Skrives også:
      </span>
      <span
        class="article-content__text article-content__text--primary article-content__politiken-grid-content"
      >
        <b>{{ word.alternativeSpelling }}</b
        ><sup>{{ word.alternativeSpellingHnr }}</sup>
        &nbsp;
        <span v-html="word.alternativeSpellingFlexion" />
        <span v-if="word.alternativeSpellingTwo">
          el. <b>{{ word.alternativeSpellingTwo }}</b>
          &nbsp;
          <span v-html="word.alternativeSpellingFlexionTwo" />
        </span>
      </span>
    </div>
    <div
      v-if="word.syllable"
      class="article-content__politiken-word-elaboration article-content__politiken-grid"
    >
      <span class="article-content__text article-content__politiken-grid-label">Deles: </span>
      <span
        class="article-content__text article-content__text--primary article-content__politiken-grid-content"
      >
        <span v-html="word.syllable" />
        &nbsp;
        <span v-if="word.alternativeSpellingSyllable" v-html="word.alternativeSpellingSyllable" />
      </span>
    </div>
    <div
      v-if="word.abbreviation"
      class="article-content__politiken-word-elaboration article-content__politiken-grid"
    >
      <span class="article-content__text article-content__politiken-grid-label">Forkortes: </span>
      <b>
        <span
          class="article-content__text article-content__text--primary article-content__politiken-grid-content"
          v-html="word.abbreviation"
        />
      </b>
    </div>
  </div>
</template>
